const EPISODE_EDITOR_REGEX = /^\/dashboard\/episode\/([^/]+\/edit)?$/;
const EPISODE_OPTIONS_REGEX = /^\/dashboard\/episode\/([^/]+\/metadata\/edit)?$/;

export const getShowNewEpisodeButton = (currentPath: string) => {
  // never show new episode button if the user is creating a new episode on the episode builder
  if (currentPath === '/dashboard/episode/new') {
    return false;
  }

  // don't show new episode button when editing existing episode in the episode builder
  if (currentPath.match(EPISODE_EDITOR_REGEX)) {
    return false;
  }

  // if the user is on the episode options page, do not show button
  if (currentPath.match(EPISODE_OPTIONS_REGEX)) {
    return false;
  }

  // otherwise, show button
  return true;
};
